
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import Candidate, { CandidateGet } from "@/lib/model/exam/candidate";
import ModalTitle from "@/lib/model/exam/modal-title";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import track from "@/lib/common/track";
import _, { random } from "lodash";

class ExamItem {
  id = 0;
  name = "";
  remark = "";
}

@Component({
  components: {
    ModalHeader
  }
})
export default class AddOneCandidateModal extends Vue {
  @Prop() candidateCreateForm!: CandidateCreateForm;
  @Prop() private examName!: string;
  @Prop() private examRemark!: string;
  @Prop() private isVisible!: boolean;
  @Prop() private paperId!: number;
  @Prop() private examAll!: ExamItem[];
  companyId = Auth.companyId;
  name = "add-one-candidate";
  modalTitle = new ModalTitle();
  modalTitle2 = new ModalTitle();
  candidateListForm = new CandidateListForm();
  isShowModal1 = false; // 是否展示 候选人已存在的提示modal
  showRepeatInterview = false; // 是否展示 邀请重面提示modal
  candidateGetForm = new CandidateGet();
  currentCandidateId = 0;
  modalType = "add"; // 弹框类型 主要区分关闭添加候选人弹框的 addCancel 和 noticeCancel
  candidateRepeatCreateForm = new CandidateRepeatCreateForm();
  isVisibleTag = false;
  examFiltedAll: ExamItem[] = new Array<ExamItem>();
  selectedPaperId: any = ""; //选定的面试ID
  showSelectError = false;
  showNameError = false;
  showMobileError = false;
  canSelected = true;
  clickable = false;
  examSelected = ""; //展示用
  hasEmail = false; //是否有邮箱字段
  tagList: string[] = [];

  checkEmail() {
    if (!this.selectedPaperId) return (this.hasEmail = false);

    Candidate.checkEmail({ examId: this.selectedPaperId }).then(res => {
      if (res.code === 0) {
        this.hasEmail = res.data.hasEmail;
      }
    });
  }

  async created() {
    this.candidateCreateForm.sendMessage = true;
    this.getTagList();
  }
  mounted() {
    this.isVisibleTag = this.isVisible;
    this.modalTitle.title = "添加一位候选人";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = this.examName;
    if (this.examAll?.length) {
      this.examFiltedAll = this.examAll.filter((examRes: any) => {
        return examRes.id > 0;
      });
    }

    console.log(this.paperId);
    if (this.paperId > 0) {
      this.examSelected = this.examName;
      this.selectedPaperId = this.paperId;
      this.checkEmail();
      this.canSelected = false;
    }
    this.candidateCreateForm.paramList = [
      {
        name: "姓名",
        isRequired: 1,
        value: "",
        type: 0,
        isShow: 1,
        sort: 0,
        extraData: "name"
      },
      {
        name: "手机",
        isRequired: 1,
        value: "",
        type: 0,
        isShow: 1,
        sort: 0,
        extraData: "phone"
      },
      {
        name: "邮箱",
        isRequired: 0,
        value: "",
        type: 0,
        isShow: 1,
        sort: 0,
        extraData: "email"
      }
    ];
  }

  @Emit("on-add-cancel")
  addCancel() {
    this.candidateCreateForm.tagList = [];
    this.isVisibleTag = false;
  }

  @Emit("on-notify-cancel")
  notifyCancel() {
    this.modalType = "";
    this.isVisibleTag = true;
    this.noticeCancel();
  }

  @Emit("on-recreate-cancel")
  handleRepeatInterviewClose() {
    this.modalType = "";
    this.showRepeatInterview = false;
    this.isVisibleTag = true;
  }

  @Watch("candidateCreateForm", { deep: true })
  onParamListChange() {
    const requiredResult = this.candidateCreateForm.paramList.filter(
      (res: StructParam) => res.isRequired == 1
    );
    const result = this.candidateCreateForm.paramList.filter(
      (res: StructParam) => res.isRequired == 1 && res.value !== ""
    );
    if (result.length === requiredResult.length && this.selectedPaperId > 0) {
      this.clickable = true;
    } else {
      this.clickable = false;
    }
  }

  repeatInterviewSubmit() {
    this.candidateRepeatCreateForm.examId = this.paperId
      ? this.paperId
      : this.candidateCreateForm.examId;
    this.candidateRepeatCreateForm.companyId = parseInt(Auth.companyId);
    this.candidateRepeatCreateForm.sendMessage = 1;
    this.candidateRepeatCreateForm.candidateId = this.currentCandidateId;
    Candidate.candidateRepeatCreate(this.candidateRepeatCreateForm)
      .then(resp => {
        console.log("resp: ", resp);
        // if (resp.code === 0 && resp.data[0].isOk) {
        if (resp.code === 0) {
          this.$message.success("邀请成功");
        } else {
          this.$message.error(resp.message);
        }
      })
      .finally(() => {
        this.showRepeatInterview = false;
      });
  }

  examSelect(paperId: number) {
    this.selectedPaperId = paperId;
    this.showSelectError = false;
    this.checkEmail();
  }

  repeatInterviewCancel() {
    this.showRepeatInterview = false;
    this.modalType = "";
    this.noticeCancel();
  }

  checkParams() {
    let checkFlag = true;

    if (this.selectedPaperId == 0) {
      this.showSelectError = true;
      checkFlag = false;
    }
    this.candidateCreateForm.paramList.forEach((item: any, key: number) => {
      if (item.name == "姓名" && item.value == "") {
        this.showNameError = true;
        checkFlag = false;
      } else if (item.name == "姓名" && item.value !== "") {
        this.showNameError = false;
        this.candidateCreateForm.showName = item.value;
      }
      if (item.name == "手机" && item.value == "") {
        this.showMobileError = true;
        checkFlag = false;
      } else if (item.name == "手机" && item.value !== "") {
        this.showMobileError = false;
        this.candidateCreateForm.phone = item.value;
      }
    });
    return checkFlag;
  }
  @Emit("on-success-status")
  onSuccessStatus() {
    return true;
  }

  // @Emit("on-add-submit")
  addSubmit(continueAdd = false) {
    const checkRes = this.checkParams();
    if (!checkRes) {
      return;
    }
    const addPaperId = this.selectedPaperId
      ? this.selectedPaperId
      : this.paperId;
    this.candidateCreateForm.examId = addPaperId;
    track("click_add_candidate", {
      exam_id: this.candidateCreateForm.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      add_type: "添加一位",
      operation_type: "按钮点击",
      operation_name: "完成",
      click_from: "从左侧候选人菜单进入候选人列表页"
    });
    this.candidateCreateForm.sendMessage = this.candidateCreateForm.sendMessage
      ? 1
      : 0;
    // 查询该手机号是否有记录，且当前是什么状态
    this.candidateListForm.companyId = parseInt(Auth.companyId);
    this.candidateListForm.examId = addPaperId;
    // 获取收集号码
    let userName = "";
    this.candidateCreateForm.paramList.forEach((item: any, key: number) => {
      if (item.name === "手机") {
        this.candidateListForm.phone = item.value;
      } else if (item.name === "姓名") {
        userName = item.value;
      }
      //加个邮箱
      if (item.name === "邮箱") {
        this.candidateCreateForm.email = item.value;
      }
    });
    // 必填的信息判断
    if (!this.candidateListForm.phone || !userName) {
      this.$message.error("缺少必填的登记信息");
      if (this.candidateCreateForm.sendMessage === 1) {
        this.candidateCreateForm.sendMessage = true;
      }
      return;
    }

    this.candidateListForm.sortKey = "created_time";
    this.candidateListForm.sortDict = "desc";

    ExamList.getCandidateList(this.candidateListForm)
      .then(res => {
        // if (res.code === 0 && res.data.list.length === 0) {
        //本场面试下无本号码候选人
        const createFormParams = _.cloneDeep(this.candidateCreateForm);
        createFormParams.paramList = [];
        Candidate.candidateCreate(createFormParams)
          .then(res => {
            if (res.code === 0) {
              if (continueAdd) {
                this.candidateCreateForm.paramList.forEach((list, idx) => {
                  this.candidateCreateForm.paramList[idx].value = "";
                });
                this.candidateCreateForm.tagList = [];
              }

              this.$message.success("添加成功");
              this.onSuccessStatus();
            } else {
              this.$message.error("添加失败，已存在相同手机号的候选人正在答题");
            }
          })
          .then(() => {
            if (!continueAdd) {
              this.addCancel();
            }
          });
      })
      .finally(() => {
        if (this.candidateCreateForm.sendMessage === 1) {
          this.candidateCreateForm.sendMessage = true;
        }
      });
  }

  @Emit("on-close-one")
  handleClose() {
    this.candidateCreateForm.tagList = [];
    console.log("on-close-one");
  }

  noticeSubmit() {
    this.candidateGetForm.candidateId = this.currentCandidateId;
    this.candidateGetForm.companyId = parseInt(Auth.companyId);
    if (this.candidateGetForm.candidateId > 0) {
      Candidate.noticeCandidate(this.candidateGetForm)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("通知成功");
            this.isShowModal1 = false;
          } else {
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.isShowModal1 = false;
          this.addCancel();
        });
    } else {
      this.$message.error("请选择需要通知的候选人");
    }
  }

  noticeCancel() {
    this.modalTitle.title = "添加一位候选人";
    this.modalTitle.hasDesc = true;
    this.isShowModal1 = false;
    this.isVisibleTag = true;
  }

  checkNameVal(name: string) {
    this.showNameError = name ? false : true;
  }

  checkMobileVal(mobile: number) {
    this.showMobileError = mobile ? false : true;
  }

  getTagList() {
    const params = {
      companyId: Auth.companyId
      // connectCode: this.connectCode,
      // judgeOutId: this.judgeOutId,
      // passwd: this.passwd
    };
    ExamList["companyTags"](params).then(res => {
      if (res.code === 0) {
        // for (let i = 0; i < 10000; i++) {
        //   res.data.tag.push("tag" + Math.random());
        // }
        this.tagList = Object.freeze(res.data.tag);
        this.filterTagList = [...this.tagList.slice(0, 100)];
      }
    });
  }
  filterTagList: readonly string[] = [];
  searching = false;
  //性能优化：最多展示前100条，或者搜索结果  --客户电脑配置低
  filterTag(query?: string) {
    console.log("00000");
    if (this.searching) return;
    this.searching = true;
    console.log(2);

    if (!query) {
      console.log(3);

      this.filterTagList = [...this.tagList.slice(0, 100)];
      console.log(4);

      this.$nextTick(() => {
        this.searching = false;
      });
      console.log(5);

      return;
    }
    console.log(new Date());
    console.log(11);

    const res = this.tagList.filter((item: string) => {
      return item.indexOf(query) > -1;
    });
    console.log(12);

    this.filterTagList = res.slice(0, 100);
    console.log(13);

    this.$nextTick(() => {
      this.searching = false;
    });
    console.log(14);

    console.log(new Date());
  }
  //搜索失焦后 空结果重置
  checkTagList() {
    this.filterTag();
  }
}
